import {
	Box,
	Checkbox,
	Divider,
	FormControl,
	FormControlLabel,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import React from "react";
import { sizes } from "./editScenarioNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./editScenarioNewSlice";
import { useEffect } from "react";
import BreakdownUpload from "./BreakdownUpload";
import MarketShareComparisonModal from "./MarketShareComparisonModal";
import { WidthFull } from "@mui/icons-material";
import { right } from "@popperjs/core";
import BreakdownSKUUpload from "./BreakdownSKUUpload";

const commonHeight = sizes.h35;
const SW = sizes.w300;
const MW = sizes.w300;

export default function CustomerBdMethod() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const {
		customerBreakdownType,
		customerBreakdown,
		emailNotification,
		CBDMType,
		CBDMPeriod,
		email,
		editScDetails,
		scenarioExternalDataSource,
		marketShareComparisonList,
		skuBreakdown,
		selectedDSs,
		scenarioExternalDataSourceSKU
	} = setupState;

	useEffect(() => {
		if (editScDetails !== null) {
			// dispatch(
			// 	setState(
			// 		"customerBreakdownType",
			// 		editScDetails.customerBreakdownType
			// 	)
			// );
			// dispatch(
			// 	setState("customerBreakdown", editScDetails.customerBreakdown)
			// );
			// dispatch(
			// 	setState("emailNotification", editScDetails.emailNotification)
			// );
			// dispatch(setState("email", editScDetails.email));
		}
	}, [editScDetails]);

	//
	// customerBreakdown

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
		if (stateName == "customerBreakdownType") {
			if (value !== "Scenario SKUs" && value !== "Reference SKUs" && value !== "Dynamic Market Share") {
				dispatch(setState("customerBreakdown", ""));
			}else{
				if(customerBreakdown === undefined || customerBreakdown === null || customerBreakdown === ""){
				  dispatch(setState("customerBreakdown", "Internal 3 months"));
				}
			}
			if (value != "External") {
				dispatch(setState(scenarioExternalDataSource, []));
			}
		}
		else if(stateName == "customerBreakdown"){
			if(marketShareComparisonList==null || marketShareComparisonList.length===0){
				dispatch(setState("MarketShareTimePeriod",value));
				dispatch(setState("PreviousMarketShareTimePeriod",value));
			}
		}
		else if(stateName == "skuBreakdown"){
			if(value != "External"){
				dispatch(setState(scenarioExternalDataSourceSKU,[]));
			}
		}
	};

	const handleCheckedUpdate = (event, stateName) => {
		const option = event.target.checked;
		dispatch(setState(stateName, option));
	};

	return (
		<Box>
			<Box sx={{ mt: 2 }}>
				<Grid container columns={12} justifyContent="space-between" alignItems="right" spacing={2}>
					<Grid item sm={12}>
						<Box
							sx={{
								border: 1,
								borderRadius: 1,
								p:2,
								marginLeft: "auto",
								borderColor:"#c6c6c6",
							}}
						>
							    <Typography varient="subtitle2" mt={1} mb={3} fontWeight={600} fontSize={14} sx={{color:"#131314"}}>Customer Breakdown Methodology</Typography>
								<Grid container columns={12} justifyContent="space-between" alignItems="right" spacing={3}>
								

									<Grid item sm={12} md={8.8} lg={8.8}>
										<Box>
											<FormControl sx={{width:"100%",}}>
												<InputLabel id="demo-simple-select-label">
													Type
												</InputLabel>
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													value={customerBreakdownType}
													label="Country"
													sx={{
														height: commonHeight,
														width: SW,
														color: "black.main",
											
													}}
													onChange={(event) =>
														handleStateUpdate(
															event,
															"customerBreakdownType"
														)
													}
												>
													{CBDMType.map((type, index) => {
														return (
															<MenuItem key={index} value={type}>
																{type}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</Box>
									</Grid>
									{(customerBreakdownType == "Scenario SKUs" || customerBreakdownType == "Reference SKUs" || customerBreakdownType == "Dynamic Market Share") && (
										<Grid item sm={12} md={3.2} lg={3.2}>
											<Box>
												<FormControl sx={{width:"100%",}}>
													<InputLabel id="demo-simple-select-label">
														Period
													</InputLabel>
													<Select
														labelId="demo-simple-select-label"
														id="demo-simple-select"
														value={customerBreakdown}
														label="Country"
														sx={{
															height: commonHeight,
															width: SW,
															color: "black.main",
															mt: 1,
														}}
														onChange={(event) =>
															handleStateUpdate(
																event,
																"customerBreakdown"
															)
														}
													>
														{CBDMPeriod.map((period, index) => {
															return (
																<MenuItem
																	key={index}
																	value={period}
																>
																	{period}
																</MenuItem>
															);
														})}
													</Select>
												</FormControl>
											</Box>
										</Grid>
									)}
									<Grid item sm={12} md={2.9} lg={2.9} sx={{minWidth: "300px"}}>
										<Box>
											<MarketShareComparisonModal />
										</Box>
									</Grid>
									</Grid>
							
							{(customerBreakdownType === "External") && (
								<Box>
									<BreakdownUpload />
								</Box>
							)}
						</Box>
					</Grid>

					<Grid container columns={12}
					sx={{
						border: 1,
						borderRadius: 1,
						p:2,
						// marginLeft: "auto",
						borderColor:"#c6c6c6",
						ml: 2,
						mt: 2,
					}}
					>
						<Divider sx={{ mt: 4 }} />
						 <Typography varient="subtitle2" mt={1} fontWeight={600} fontSize={14} sx={{color:"#131314", width: "100%"}}>SKU Breakdown Methodology</Typography>
					<Grid item sm={6} md={4} lg={3} mt={2}>
						<Box>
							<FormControl sx={{width: "100%",}}>
								<InputLabel id="demo-simple-select-label">
									SKU Breakdown Methodology
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={skuBreakdown}
									label="SKU Breakdown Methodology"
									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									}}
									onChange={(event) =>
										handleStateUpdate(event, "skuBreakdown")
									}
								>
									{selectedDSs?.map((source, index) => {
										if (source !== "Forecast") {
											return (
												<MenuItem key={index} value={source}>
													{source}
												</MenuItem>
											);
										}
										return null;
									})}
									<MenuItem value={"External"}>External</MenuItem>
								</Select>
							</FormControl>
						</Box>
					</Grid>

					<Grid columns={4} item md={8} lg={9}alignContent={"flex-end"}>
						<Box list sm={2}
							sx={{
								display: "flex",
								flexDirection: "row",
								justifyContent: "flex-start",
							}}
						>
							
							<FormControlLabel sx={{ mt: 0.3, ml: "calc(100% - 542px)", alignContent:"flex-end" }}
								control={
									<Checkbox
										checked={emailNotification}
										onChange={(event) =>
											handleCheckedUpdate(event, "emailNotification")
										}
										inputProps={{ "aria-label": "controlled" }}

									/>
								}
							/>

							<Typography sx={{ mt: 1.5, ml:-2, }}>
								Send Email Notification
							</Typography>
						
							<TextField
								id="outlined-basic"
								label="Email Address"
								variant="outlined"
								size="small"
								sx={{
									height: commonHeight,
									width: MW,
									ml: 2,
									mt: .5,
								}}
								value={email}
								onChange={(event) => handleStateUpdate(event, "email")}
							/>
						</Box>
					</Grid>
					{(skuBreakdown === "External") && (
							<Box>
								<BreakdownSKUUpload />
							</Box>
					)}

				</Grid>	
				</Grid>
			</Box>

			{/* <Divider sx={{ mt: 4 }} /> */}
		</Box>
	);
}
